var _title, _rect, _rect2, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLinkedin = function SvgLinkedin(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#2a66bc",
    height: 412.22,
    rx: 55.43,
    width: 412.22,
    x: 49.89,
    y: 49.89
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#fefefe",
    height: 158.08,
    width: 48.9,
    x: 138.56,
    y: 216
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 163.01,
    cy: 162.58,
    fill: "#fefefe",
    r: 26.46
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M337.6,217.18s-13.6-4.41-34.78-1.41a45.63,45.63,0,0,0-21.23,8.49,35.47,35.47,0,0,0-12.25,16.19V216h-48.9V374.08h48.9V288c0-13.05,7-25.59,18.83-31a31.72,31.72,0,0,1,10.14-2.76s11.14-2.23,20.9,8.76c5.29,6,7.73,13.94,7.73,21.91v89.23h48.9V264.9C378,225,337.6,217.18,337.6,217.18Z",
    fill: "#fefefe"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLinkedin);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgZGF0YS1uYW1lPSJMYXllciAxIiBpZD0iTGF5ZXJfMSIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHRpdGxlLz48cmVjdCBmaWxsPSIjMmE2NmJjIiBoZWlnaHQ9IjQxMi4yMiIgcng9IjU1LjQzIiB3aWR0aD0iNDEyLjIyIiB4PSI0OS44OSIgeT0iNDkuODkiLz48cmVjdCBmaWxsPSIjZmVmZWZlIiBoZWlnaHQ9IjE1OC4wOCIgd2lkdGg9IjQ4LjkiIHg9IjEzOC41NiIgeT0iMjE2Ii8+PGNpcmNsZSBjeD0iMTYzLjAxIiBjeT0iMTYyLjU4IiBmaWxsPSIjZmVmZWZlIiByPSIyNi40NiIvPjxwYXRoIGQ9Ik0zMzcuNiwyMTcuMThzLTEzLjYtNC40MS0zNC43OC0xLjQxYTQ1LjYzLDQ1LjYzLDAsMCwwLTIxLjIzLDguNDksMzUuNDcsMzUuNDcsMCwwLDAtMTIuMjUsMTYuMTlWMjE2aC00OC45VjM3NC4wOGg0OC45VjI4OGMwLTEzLjA1LDctMjUuNTksMTguODMtMzFhMzEuNzIsMzEuNzIsMCwwLDEsMTAuMTQtMi43NnMxMS4xNC0yLjIzLDIwLjksOC43NmM1LjI5LDYsNy43MywxMy45NCw3LjczLDIxLjkxdjg5LjIzaDQ4LjlWMjY0LjlDMzc4LDIyNSwzMzcuNiwyMTcuMTgsMzM3LjYsMjE3LjE4WiIgZmlsbD0iI2ZlZmVmZSIvPjwvc3ZnPg==";